"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigation = void 0;
var react_1 = __importDefault(require("react"));
var useCart_1 = require("../hooks/useCart");
var CartDialog_1 = require("./CartDialog");
function Navigation() {
    var _a = react_1.default.useState(false), dialogOpen = _a[0], setDialogOpen = _a[1];
    var count = (0, useCart_1.useCart)().count;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("nav", { className: "navbar navbar-light bg-light sticky-top shadow", style: { zIndex: 1025 } },
            react_1.default.createElement("div", { className: "container" },
                react_1.default.createElement("a", { className: "navbar-brand", href: "index.html" },
                    react_1.default.createElement("img", { src: "https://info3.readytoschool.nl/_general/images/Logo_groen_Readytoschool.png", height: "25px", className: "d-inline-block align-top", alt: "" })),
                react_1.default.createElement("a", { className: "btn btn-green1 text-white", "data-toggle": "modal", "data-target": "#shopcart" },
                    react_1.default.createElement("span", { className: "d-none d-md-inline ml-2 mr-2" }, "Winkelwagen"),
                    react_1.default.createElement("i", { className: "fas fa-shopping-cart mr-md-2", id: "shopcartImage" }),
                    react_1.default.createElement("span", { id: "shopcartAmount", className: "badge badge-orange position-absolute rounded-circle p-2", style: {
                            fontSize: "12pt",
                            top: "unset",
                            bottom: "-5px",
                            width: 32,
                            height: 32,
                            display: count ? "initial" : "none",
                        } }, count)))),
        react_1.default.createElement(CartDialog_1.CartDialog, { open: dialogOpen, onClose: function () { return setDialogOpen(false); } })));
}
exports.Navigation = Navigation;
